import MentionIcon from '@atlaskit/icon/glyph/mention';
import type { AddFlagProps } from '@databases/flags/types';
import React from 'react';

import { messages } from './i18n';
import { BuildProps, MentionBuilder, MentionBuilderCriteria } from './types';
import { getDisplayNameForUsers } from './utils/getDisplayNameForUsers';

export class MentionFlagForTwoUsers implements MentionBuilder {
  shouldShowFlag({ usersWithAccess }: MentionBuilderCriteria): boolean {
    return usersWithAccess.length === 2;
  }
  build({
    formatMessage,
    usersWithAccess,
    isLocked,
    showPanel,
    fieldId,
  }: BuildProps): AddFlagProps {
    const { displayName, somebodyElse } = getDisplayNameForUsers({
      users: usersWithAccess,
    });
    const actions = [
      {
        content: formatMessage(
          messages['mention-notification.flag-go-to-field-settings-cta']
        ),
        onClick: () => showPanel('FieldSettingsPanel', { fieldId }),
      },
    ];

    return {
      title: formatMessage(
        messages['mention-notification.flag-mention-notification-title-two-users'],
        {
          displayName,
          somebodyElse,
        }
      ),
      description: !isLocked
        ? formatMessage(
            messages['mention-notification.flag-mention-notification-description']
          )
        : formatMessage(
            messages[
              'mention-notification.flag-mention-notification-description-without-field-settings'
            ]
          ),
      icon: <MentionIcon label="" />,
      actions: !isLocked ? actions : undefined,
    };
  }
}
